import { useMyOrgId, useOrganizationByPath } from '../layouts/AppStateContextLayout/utils'

/**
 * Returns the active organization ID for the current context.
 *
 * Priority order:
 * 1. The organization from the URL path/slug (most specific context)
 * 2. The user's organization (fallback for pages without org slug)
 *
 * This hook centralizes the logic for determining which org ID to use when
 * calling backend endpoints that require an explicit organizationId parameter.
 *
 * The URL path takes precedence because it represents the most specific context.
 * For example, a staff member from Org A can view citizen-facing pages for Org B
 * by visiting a URL with Org B's slug.
 *
 * In the future, this will be updated to support multi-org membership with
 * an org switcher, tracking the user's selected org in session/local storage.
 */
export const useActiveOrgId = (): number | undefined => {
  const myOrgId = useMyOrgId()
  const orgByPath = useOrganizationByPath()

  return orgByPath?.id ?? myOrgId
}
